import BaseDangerDetail from '../../../common/baseDangerDetail/BaseDangerDetail';
import { fieldAnomaly } from '../../../../../utils/formatter';
import { checkSearch, formatListData } from '../../../common/commons';

export default class MainSupplierChange extends BaseDangerDetail {
    constructor(props) {
        super(props);
        this.title = '前五名供应商情况';
        this.rowKey = 'rowNum';
    }

    getColumns = () => {
        let year = checkSearch().reportYear;
        return [{
            title: year,
            dataIndex: 'supplierName',
            render: fieldAnomaly
        }, {
            title: '采购额',
            dataIndex: 'supplierAmout',
            render: fieldAnomaly
        }, {
            title: year - 1,
            dataIndex: 'name',
            render: fieldAnomaly
        }, {
            title: '采购额',
            dataIndex: 'amout',
            render: fieldAnomaly
        }];
    };

    formatResponse = (data) => {
        data = data || {};
        return {
            data: formatListData(data.supplierList, 'supplier')
        };
    };
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/financialFraudAnalysis/subComponents/details/MainSupplierChange.jsx